import styled from 'styled-components';
import BgPage from 'assets/images/bg-banner_assinatura_digital_vendas.png';

export const Container = styled.div`
  background-color: #f6f0ff;

  .bg-img {
    background: url('${BgPage}') #f6f0ff top center no-repeat;
    background-size: cover;
  }

  .loading-page {
    height: calc(100vh - 56px);
  }

  button {
    background: #6cd8b4;
    box-shadow: 20px 20px 80px rgba(0, 0, 0, 0.15);
    font-size: 16px;
    color: #20233c;
    font-weight: bold;
  }

  h1 {
    color: #20233c;
  }

  h3 {
    color: rgba(32, 35, 60, 0.83);
  }

  .titulo-personalizado {
    color: #6cd8b4;
    font-size: 52px;
    margin-top: 10px;
  }
  .beneficios {
    font-weight: 500;
    font-size: 20px;
  }

  .preco-anterior {
    font-weight: 400;
    font-size: 21.3228px;
    color: #40475c;
  }

  .preco-anterior span {
    font-weight: 600;
    font-size: 38.9976px;
    color: #848484;
  }

  .preco-atual {
    color: #20233c;
    font-weight: 600;
    font-size: 18.43px;
  }

  .preco-promocao span {
    font-weight: 700;
    font-size: 48px;
    color: #20233c;
  }

  .preco-atual span {
    font-weight: 700;
    font-size: 61.4377px;
    color: #20233c;
  }

  .card-sale {
    background: #ebe1fb;
    border: 4.07348px solid #c7bce8;
    border-radius: 16.7019px;
  }

  .h3-list {
    color: #20233c;
    font-weight: 700;
    font-size: 38px;
    line-height: 60px;
  }

  h2 {
    font-weight: 500;
    font-size: 53px;
    color: #20233c;
  }

  .descricao {
    font-weight: 500;
    font-size: 24px;
    color: #40475c;
  }

  .autor-comentario {
    font-weight: 600;
    font-size: 16px;
    color: #20233c;
  }

  .desc {
    font-size: 16px;
    line-height: 24px;
    color: #40475c;
  }

  .border-number {
    border: 4.07348px solid #6cd8b4;
    border-radius: 16.7019px;
  }

  .subtitle {
    color: #20233c;
    font-weight: 500;
    font-size: 20px;
  }

  .contrate {
    width: 350px;
    height: 50px;
  }
  .p-desc {
    font-weight: 500;
    font-size: 24px;
    line-height: 36px;
  }
`;
